/**
 * navigation/ViewRouter
 * ──────────────────────────────────────────────────────────────────────────
 * View key → screen. One exhaustive switch, and the `never` fallthrough is
 * deliberate: adding a view to routes.ts without a screen here is a TYPE ERROR,
 * not a blank page in production.
 * ──────────────────────────────────────────────────────────────────────────
 */
import ApprovalsScreen from '../screens/Approvals';
import ApproverDecidedScreen from '../screens/ApproverDecided';
import ApproverQueueScreen from '../screens/ApproverQueue';
import AssignmentRegisterScreen from '../screens/AssignmentRegister';
import MyCashScreen from '../screens/MyCash';
import MyTransactionsScreen from '../screens/MyTransactions';
import OverviewScreen from '../screens/Overview';
import PolicyInForceScreen from '../screens/PolicyInForce';
import ReconciliationScreen from '../screens/Reconciliation';
import SettingsScreen from '../screens/Settings';
import SettlementAlertsScreen from '../screens/SettlementAlerts';
import SyncLogScreen from '../screens/SyncLog';
import type { ViewKey } from './routes';

export function ViewRouter({ view }: { view: ViewKey }) {
  switch (view) {
    // Finance
    case 'overview':
      return <OverviewScreen />;
    case 'register':
      return <AssignmentRegisterScreen />;
    case 'recon':
      return <ReconciliationScreen />;
    case 'approvals':
      return <ApprovalsScreen />;
    case 'router':
      return <SyncLogScreen />;
    case 'settle':
      return <SettlementAlertsScreen />;
    case 'settings':
      return <SettingsScreen />;
    // Approver
    case 'queue':
      return <ApproverQueueScreen />;
    case 'decided':
      return <ApproverDecidedScreen />;
    case 'rules':
      return <PolicyInForceScreen />;
    // Custodian
    case 'mycash':
      return <MyCashScreen />;
    case 'myledger':
      return <MyTransactionsScreen />;
    default: {
      // Exhaustiveness check: a new ViewKey without a case fails to compile.
      const unreachable: never = view;
      return unreachable;
    }
  }
}

export default ViewRouter;
